module.exports = __webpack_public_path__ + "img/haibao4@2x_new.9688f1d1.png";